// extracted by mini-css-extract-plugin
export default {"tagsWrapper":"TableCard_tagsWrapper__BOJYV"};